<template>
    <ConfirmationDialog
        v-model:open="open"
        :title="dialogTitle"
        :text="dialogText"
        :confirm-label="buttonText"
        :cancel-label="t('common.cancel')"
        container-class="max-w-[480px] h-[450px]"
        @confirm="handleConfirm"
        @cancel="handleCancel">
        <template #icon>
            <FeedbackRequestIcon />
        </template>
    </ConfirmationDialog>
</template>

<script setup>
import ConfirmationDialog from "~vue/components/ConfirmationDialog.vue";
import FeedbackRequestIcon from "~vue/icons/FeedbackRequestIcon.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps({
    dialogTitle: { type: String, required: true },
    dialogText: { type: String, required: true },
    buttonText: { type: String, required: true },
});

const emit = defineEmits(["confirm"]);

const open = defineModel("open", {
    type: Boolean,
    required: true,
});

const handleConfirm = () => {
    emit("confirm");
};

const handleCancel = () => {
    open.value = false;
};
</script>
